<template>
  <div class="max-w-lg mx-auto p-8 bg-white shadow-md rounded space-y-6">
    <StepIndicator :step="step" v-if="step > 0 && step <= 2" />
    <StepHeading :step="step" :submitted="submitted" />
    <Step0 v-if="step === 0" @next="step = 1" />
    <Step1 v-if="step === 1" v-model="data" @next="step = 2" />
    <Step2
      v-if="step === 2"
      :model-value="data"
      @update:modelValue="updateData"
      :options="needsOptions"
      @next="step = 4" />
    <Step4 v-if="step === 4 && !submitted" :name="data.name" :email="data.email" :need="data.need" @skip="step = 5" />
    <GDPROptIn v-if="step === 5 && !submitted" @accept="acceptFollowup" @decline="step = 6" />
    <ThankYou v-if="submitted" />
    <Goodbye v-if="step === 6 && !submitted" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";

import StepIndicator from "./StepIndicator.vue";
import StepHeading from "./StepHeading.vue";
import Step0 from "./Step0.vue";
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step4 from "./Step4.vue";
import GDPROptIn from "./GDPROptIn.vue";
import ThankYou from "./ThankYou.vue";
import Goodbye from "./Goodbye.vue";

// now name/email/need/subscribe are all required; 'goal' remains optional
interface ConsultationLeadData {
  goal?: string;
  name: string;
  email: string;
  need: string;
  subscribe: boolean;
}

export default defineComponent({
  name: "ConsultationLeadForm",
  components: {
    StepIndicator,
    StepHeading,
    Step0,
    Step1,
    Step2,
    Step4,
    GDPROptIn,
    ThankYou,
    Goodbye,
  },
  setup(_, { expose }) {
    const { t, locale, messages } = useI18n();
    const step = ref<number>(0);
    const submitted = ref<boolean>(false);

    // initialize all required fields
    const data = reactive<ConsultationLeadData>({
      goal: undefined,
      name: "",
      email: "",
      need: "",
      subscribe: false,
    });

    const needsOptions = computed<string[]>(() => {
      const m = messages.value[locale.value] as any;
      return m?.totalForm?.needsOptions || [];
    });

    function acceptFollowup(): void {
      data.subscribe = true;
      submitted.value = true;
    }

    // merge updated data from Step2
    function updateData(val: ConsultationLeadData): void {
      Object.assign(data, val);
    }

    expose({
      goToStep: (n: number): void => {
        step.value = n;
      },
    });

    return {
      t,
      step,
      data,
      submitted,
      needsOptions,
      acceptFollowup,
      updateData,
    };
  },
});
</script>
